'use client';

import React from 'react';
import Section from './components/section';
import { RendererProps } from './types';

const Renderer = ({
  data: pageData,
  params,
  searchParams,
  currentHighlight,
  gridClassName = '',
  wrapperClassName = '',
  categories = [],
  flattenedCategories = [],
}: RendererProps) => {
  const { page, data } = pageData;

  const sections = [
    page.sections.head,
    page.sections.main,
    page.sections.footer,
  ];

  return (
    <div className="flex min-h-screen flex-col items-stretch justify-start">
      {sections.filter(Boolean).map((section) => (
        <Section
          key={section?.sectionId}
          section={section}
          dataSources={data.dataSources}
          params={params}
          searchParams={searchParams}
          categories={categories}
          flattenedCategories={flattenedCategories}
          currentHighlight={currentHighlight}
          gridClassName={gridClassName}
          wrapperClassName={wrapperClassName}
        />
      ))}
    </div>
  );
};

export default Renderer;
